// src/lib/mcp_agent.ts — identitatea AGENTULUI MCP al unei primării (PUR, partajat server↔client,
// zero dependințe). Un singur loc pentru adresă: de aici o iau userul de serviciu provizionat pentru
// cereri (`mcp_agent_principal`, mcp_tools.ts) și autorul scris pe ORICE versiune creată prin MCP
// (`mcp_audit`) — dacă s-ar compune în două locuri, istoricul unui obiect și cel al unei cereri ar
// putea numi „agentul” diferit. Tot aici, afișarea: adresa e una tehnică (`@system.local`, nelivrabilă),
// deci interfața o redă ca „Agent AI”, nu ca email.

/** Cum apare agentul în istoricul unui obiect / al regulamentului. */
export const MCP_AGENT_LABEL = "Agent AI"

/** Adresa userului de serviciu al agentului MCP al organizației `org_id`. */
export function mcp_agent_email(org_id: string): string {
	return `mcp-agent+${org_id}@system.local`
}

const MCP_AGENT_RE = /^mcp-agent\+[^@\s]+@system\.local$/i

/** Autorul e agentul MCP al unei primării (oricare)? */
export function is_mcp_agent(author: string | null | undefined): boolean {
	return typeof author === "string" && MCP_AGENT_RE.test(author.trim())
}

/**
 * Autorul unei versiuni, așa cum se AFIȘEAZĂ: adresa agentului → „Agent AI”; orice alt autor rămâne
 * neschimbat; fără autor → "" (apelantul decide ce pune în loc — sursa, o liniuță, nimic).
 */
export function author_label(author: string | null | undefined): string {
	if (typeof author !== "string" || author.trim() === "") {
		return ""
	}
	return is_mcp_agent(author) ? MCP_AGENT_LABEL : author
}
